/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrUserEntity } from '../../models/dbr-user-entity';

export interface UsersControllerFindByEmail$Params {
}

export function usersControllerFindByEmail(http: HttpClient, rootUrl: string, params?: UsersControllerFindByEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<DbrUserEntity>> {
  const rb = new RequestBuilder(rootUrl, usersControllerFindByEmail.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DbrUserEntity>;
    })
  );
}

usersControllerFindByEmail.PATH = '/users/byemail/{email}';
